export default {
    SUBCATEGORY(state, items) {
        state.items = items
    }
}